const debug = require('debug')('ccs:http');
import axios from 'axios';
import { Message, Loading } from 'element-ui';
import { lang } from './i18n';
import { app } from './main';
import { isProd } from './utils';

let loading;

// 默认参数
axios.defaults.params = {};
/* eslint no-undef:0 */
axios.defaults.baseURL = API_BASE_URL; // API_BASE_URL;
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
	app.$Progress.start();
	// loading = Loading.service({ fullscreen: true });
	// 测试模式
	config.headers['X-Requested-With'] = 'XMLHttpRequest';
	if (!isProd()) Object.assign(config.params, { _mode: 'dev' });
	return config;
}, (error) => {
	app.$Progress.finish();
	if (loading) loading.close();
	return Promise.reject(error);
});

axios.interceptors.response.use(({ data }) => {
	app.$Progress.finish();
	if (loading) loading.close();

	return data;
}, (err) => {
	debug('[response error]');
	app.$Progress.finish();
	if (loading) loading.close();

	if (err.response) {
		const { status, data } = err.response;
		let { requestId = '', message } = data;
		if (status === 400) {
			if (typeof data.detail === 'string') {
				message = data.detail;
			} else if (Array.isArray(data.detail)) {
				message = data.detail[0].msg;
			} else {
				message = data.message || '服务器忙。';
			}
		} else if (status === 401) {
			window.location.href = data.location;
			return;
		} else if (status === 404) {
			message = 'Not Found.';
		} else {
			message = message || '服务器忙。';
		}

		Message.error({
			showClose: true,
			message: message
		});

		// Message.error({
		// 	showClose: true,
		// 	dangerouslyUseHTMLString: true,
		// 	message: `<div>
		// 		<p style="padding: 5px; line-height: 1.4">${message}</p> 
		// 		<p style="padding: 5px; line-height: 1.4">[RequestId: ${requestId}]</p>
		// 	</div>`
		// });
	} else {
		Message.error({
			showClose: true,
			message: lang() === 'zh' ? '网络错误。' : 'Network Error',
		});
	}

	return Promise.reject(err);
});